import {
  get,
  post,
  put,
  del,

} from '../configApi'
export async function loadCategory() {
  return await get(`/category/list`)
}
export async function loadCategoryList(params) {
  return await get(`/category/list/admin`, params)
}
export async function insertCategory(body) {
  return await post(`/category/manage/insert`,body)
}
export async function updateCategory(body) {
  return await put(`/category/manage/update`,body)
}
export async function updateActive(body) {
  return await put(`/category/manage/active`,body)
}
export async function deleteCategory(body) {
  return await del(`/category/manage/delete`, body)
}
export async function getCategoryListBin(body) {
  return await get(`/category/list/adminbin`, body)
}

